<template>
  <div>
    <b-row>
      <h5 class="col-sm-12">Filtrar por</h5>

      <br />
      <b-col sm="3">
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde"
            >Fecha importación desde</label
          >
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range_created.startDate"
            :max="range_created.endDate == '' ? maxDate : range_created.endDate"
            @blur="changeDateImport()"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta"
            >Fecha importación hasta</label
          >
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range_created.endDate"
            :min="range_created.startDate"
            :max="maxDate"
            @blur="changeDateImport()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Estado</label>
          <b-form-select v-model="status_filter" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Estado--</option>
            </template>
            <option value="P">Pausado</option>
            <option value="A">Activo</option>
            <option value="C">Cerrado</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Responsable</label>
          <b-form-select v-model="staff_id_filter" @change="getDebtors()" :disabled="role_id != 1 && role_id != 8">
            <template slot="first">
              <option :value="null">-- Responsable--</option>
            </template>
            <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    
    <b-row>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Buscar por deudor</label>
          <b-form-input
            type="text"
            v-model="debtor_name_filter"
            @blur="getDebtors()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Buscar por cuenta</label>
          <b-form-input
            type="text"
            v-model="customer_name_filter"
            @blur="getDebtors()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Tipificación</label>
          <b-form-select v-model="type_filter" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Tipificación --</option>
            </template>
            <option v-for="item in lstType" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Tipo de carta</label>
          <b-form-select
            v-model="letter_filer"
            @change="getDebtors()"
          >
          <template slot="first">
            <option :value="null">
              -- Seleccionar tipo de carta --
            </option>
          </template>
          <option value="1">Carta 1</option>
          <option value="2">Carta 2</option>
          <option value="3">Carta 3</option>
        </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <div v-if="role_id == 1 || role_id == 8">
              <div class="row" v-if="selectItems.length > 0">
                <div class="col-2">
                  <b-form-group>
                    <label class="font-weight-bold mt-2" >¿ Que carta desea generar ?</label>
                  </b-form-group>
                </div>

                <div class="col-3">
                  <b-form-group>
                    <b-form-select
                      v-model="letter"
                    >
                      <template slot="first">
                        <option :value="null" >
                          -- Seleccionar tipo de carta --
                        </option>
                      </template>
                      <option value="1">Carta 1</option>
                      <option value="2">Carta 2</option>
                      <option value="3">Carta 3</option>
                    </b-form-select>
                  </b-form-group>
                </div>

                <div class="col-sm-2">
                  <b-button
                    variant="warning"
                    class="float-right col-sm-12"
                    @click="enviarcartaSeleccionados()"
                    >Generar</b-button
                  >
                </div>

                <div class="col-sm-2">
                  <b-button
                    variant="danger"
                    class="float-right col-sm-12"
                    @click="cancelSendLetter()"
                    >Cancelar</b-button
                  >
                </div>

              </div>
            </div>

            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive
              :items="items"
              :fields="fields"
              :filter="filter"
              :current-page="currentPage"
              :per-page="perPage"
            >

              <!-- SELECCIONAR TODO -->
              <!-- <template v-slot:head(selected) v-if="isAdmin">
                <input type="checkbox" @click.stop v-model="selectAll" @change="toggleSelectAll" />
              </template>-->

              <!-- <template slot="HEAD_selected" v-if="isAdmin">
                <input type="checkbox" @click.stop v-model="selectAll" @change="toggleSelectAll" />
              </template>-->

              <!-- <template v-slot:cell(selected)="data" > -->
              <template slot="selected" slot-scope="data">
                <input
                  type="checkbox"
                  v-model="data.item.selected"
                  @change="selectRow(data.item)"
                />
              </template>

              <!-- <template v-slot:cell(created_at)="data"> -->
              <template slot="created_at" slot-scope="data">
                {{ formatDateDescription(data.item.created_at)}}
              </template>

              <!-- <template v-slot:cell(letter1)="data"> -->
              <template slot="letter1" slot-scope="data">
                <i
                  v-if="data.item.letter1 == 'N'"
                  class="fa fa-times-circle fa-lg text-danger"
                ></i>
                <i v-else class="fa fa-check-circle fa-lg text-success pointer" @click="getLetterPDF(data.item, '1')" ></i>
              </template>

              <!-- <template v-slot:cell(letter2)="data"> -->
              <template slot="letter2" slot-scope="data">
                <i
                  v-if="data.item.letter2 == 'N'"
                  class="fa fa-times-circle fa-lg text-danger"
                ></i>
                <i v-else class="fa fa-check-circle fa-lg text-success pointer" @click="getLetterPDF(data.item, '2')"></i>
              </template>

              <!-- <template v-slot:cell(letter3)="data"> -->
              <template slot="letter3" slot-scope="data">
                <i
                  v-if="data.item.letter3 == 'N'"
                  class="fa fa-times-circle fa-lg text-danger"
                ></i>
                <i v-else class="fa fa-check-circle fa-lg text-success pointer" title="Descargar carta" @click="getLetterPDF(data.item, '3')"></i>
              </template>

               <!-- <template v-slot:cell(total_debt)="data"> -->
              <template slot="total_debt" slot-scope="data">
                ${{ formatPrice(data.item.total_debt) }}
              </template>

              <!-- <template v-slot:cell(task_management_date)="data"> -->
              <template slot="task_management_date" slot-scope="data">
                {{ formatDateDescription(data.item.task_management_date)}}
              </template>

              <!-- <template v-slot:cell(actions)="data"> -->
              <template slot="actions" slot-scope="data">
                <b-button
                  size="sm"
                  variant="primary"
                  class="mr-1 btn-custom-size"
                  @click="viewDebtor(data.item.id)"
                  title="Gestionar"
                  :disabled="!READ"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
              </template>
            </b-table>

            <hr />

            <div class="row">
              <div class="col-sm-4">
                Mostrando
                {{
                  items.length > perPage * currentPage
                    ? perPage * currentPage
                    : items.length
                }}
                de {{ items.length }} registros
              </div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    align="right"
                    size="sm"
                    :total-rows="
                      items.length == null
                        ? 0
                        : items.length
                    "
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>

  </div>

</template>

<script>
import UploadDataComponent from "@/components/UploadData.vue";
import UploadExcelComponent from "@/components/ImporterExcel.vue";
import DateRangePicker from "vue2-daterange-picker"; //https://github.com/Innologica/vue2-daterange-picker/blob/master/src/components/DateRangePicker.vue
import moment from "moment";
export default {
  name: "MainLetter",
  components: { UploadExcelComponent, DateRangePicker, UploadDataComponent },
  props: {
    caption: {
      type: String,
      default: "LISTADO DE DEUDORES",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      currentPage: 1,
      perPage: 10,
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      isCustomer: false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      user_id: JSON.parse(localStorage.getItem("auth"))[0].id,
      customer_id: null,
      range_task_management: {
        startDate: null,
        endDate: null,
      },

      fields: [
        {
          key: "selected",
          name: "Selected",
          label: "",
          class: "options-column",
        },
        { key: "status_name", label: "Estado", sortable: true },
        { key: "created_at", label: "F. De importación", sortable: true },
        { key: "customer_business_name", label: "Cliente", sortable: true },
        { key: "business_name", label: "Deudor" },
        { key: "debtor_email", label: "Email" },
        { key: "type_name", label: "Tipificación", sortable: true },
        { key: "total_debt", label: "Saldo a capital", sortable: true },
        { key: "task_management_date", label: "F. Ult. gestión", sortable: true },

        { key: "letter1", label: "Carta 1" },
        { key: "letter2", label: "Carta 2" },
        { key: "letter3", label: "Carta 3" },


        // { key: "staff_name", label: "Cobrador/Abogado", sortable: true },
        // { key: "process_name", label: "Etapa", sortable: true },

        { key: "actions", label: "Opciones" },
      ],

      status: null,
      items: [],
      pagination: {},
      filter: null,

      lstLetterData: [],

      errores: [],
      mostrarResumen: false,
      rowCount: -1,
      type_id: null,
      //
      selectItems: [],
      selectAll: false,

      // FILTROS DE BUSQUEDA
      created_at_filter: null,
      status_filter: "A",
      type_filter: null,
      staff_id_filter: null,
      type_task_management: null,
      pre_written: null,
      customer_staff_id_filter: null,

      // LISTAS PARA LOS FILTROS
      lstStaffs: [],
      lstType: [],
      lstTypeJury: [],
      lstComercialStaffs: [],
      lstProcess: [],
      laravelData: {},
      limit: 10,
      showDisabled: true,
      size: "small",
      align: "right",
      staff_id: null,

      letter: null,
      // NUEVOS FILTROS DESDE HASTA
      debtor_name_filter: null,
      customer_name_filter: null,
      letter_filer: null,
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range_created: {
        // startDate: sumarDias(new Date(), -30),
        startDate: moment(String(new Date("2012", "12", "01"))).format("YYYY-MM-DD"),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },

      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  mounted() {
    this.enabledActions();
    this.initParameters();
    this.getDebtors();
  },
  computed: {},
  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      // console.log('auth --------------------------------------------------------------------------->', auth);
      this.CREATE = auth.create == 1;
      this.READ = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },
    initParameters() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.isCustomer = auth[0].customer_id != null ? true : false;
      this.customer_id = auth[0].customer_id;
      this.staff_id_filter =
        this.role_id == 1 ||
        this.role_id == 8 ||
        this.role_id == 7 ||
        this.role_id == 9
          ? null
          : auth[0].staff_id;

      this.getStaffs();

      // TIPIFICACIÓN DEUDOR PREJURIDICO
      this.$http.get(`${this.$urlApi}parameters/15?token=${this.token}`).then(
        (response) => {
          this.lstType = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // TIPIFICACIÓN DEUDOR JURIDICO
      this.$http.get(`${this.$urlApi}parameters/20?token=${this.token}`).then(
        (response) => {
          this.lstTypeJury = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
      
      //LISTADO DE STAFF'S, 42: COMERCIAL
      this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
        (response) => {
          this.lstComercialStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // PROCESOS
      // this.$http.get(`${this.$urlApi}process?token=${this.token}`).then(
      //   (response) => {
      //     this.lstProcess = response.data.data;
      //   },
      //   (error) => {
      //     console.log(error);
      //   }
      // );
    },

    getStaffs() {
      //LISTADO DE STAFF'S, 43: PREJURIDICO
      this.$http.get(`${this.$urlApi}staffs/type/43?token=${this.token}`).then(
        (response) => {
          this.lstStaffs = response.data.data;
          console.log("Listado staffs",response.data.data);

          if (
            this.role_id == 1 ||
            this.role_id == 7 ||
            this.role_id == 8 ||
            this.role_id == 9
          ) {
            //LISTADO DE STAFF'S, 44: JURIDICO
            this.$http
              .get(`${this.$urlApi}staffs/type/44?token=${this.token}`)
              .then(
                (response) => {
                  console.log(response.data);
                  response.data.data.forEach((item) => {
                    if (item.type == 44) this.lstStaffs.push(item);
                  });
                },
                (error) => {
                  console.log(error);
                }
              );
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
    changeDateImport() {
      if (
        this.range_created.startDate != "" &&
        this.range_created.endDate != ""
      ) {
        this.getDebtors();
      } else return;
    },
    getDebtors: function () {
      let authAux = JSON.parse(this.auth);
      authAux[0].customer_name = this.customer_name_filter;
      authAux[0].debtor_name = this.debtor_name_filter;
      authAux[0].status = this.status_filter;
      authAux[0].type = this.type_filter;
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].letter = this.letter_filer;
      
      authAux[0].start_date_created_at = moment(this.range_created.startDate).format("YYYY-MM-DD");
      authAux[0].end_date_created_at = moment(this.range_created.endDate).format("YYYY-MM-DD");
      authAux[0].customer_staff_id_filter = this.role_id == 2 ? authAux[0].staff_id : this.customer_staff_id_filter;

      let url = `${this.$urlApi}debtors/letters/all?token=${this.token}`;
      showLoader();
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log(response);
            this.items = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getRowCount(items) {
      return items.length;
    },

    viewDebtor(id) {
      let url = `${location.origin}/#/debtors/view/${id.toString()}`;
      window.open(url, "_blank");
    },
    startDownload() {
      showLoader();
    },
    finishDownload() {
      hideLoader();
    },

    selectRow(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItems.indexOf(item);

        if (index > -1) {
          this.selectItems.splice(index, 1);
        }
      } else {
        this.selectItems.push(item);
      }
    },
    toggleSelectAll() {
      if (this.selectAll) {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = true;
          this.$set(this.items, i, updatingItem);
          this.selectItems.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = false;
          this.$set(this.items, i, updatingItem);
        }
        this.selectItems = [];
      }
    },
    formatDateDescription(value) {
      if (!value) return "";
      else {
        if (value == "--") return value;
        else {
          var d = moment(value).format("DD");
          var m = moment(value).format("MMM");
          var a = moment(value).format("YYYY");
          return d + " de " + m + " " + a;
        }
      }
    },
    formatPrice(value) {
      let val = Math.trunc(value);
      //let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    enviarcartaSeleccionados() {

      if(this.letter != null) {
        this.$swal({
          title: "Envio de cartas",
          text: `Se envara la carta ${this.letter}, a todos los deudores seleccionados, ¿Desea continuar?`,
          type: "question",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Aceptar",
        }).then((result) => {
          if (result.value) {
            this.lstLetterData = [];
            this.rowCount = 0;
            showLoader();

            this.selectItems.forEach(item => {
              
              if(item.selected) 
              {
                let letteData = 
                {
                  type: this.letter, 
                  date: null, 
                  debtor_id: item.id,
                  description: "Carta generada para el deudor: " + item.business_name,
                  status: "A",
                  ineteres: item.ineteres,
                  fees: item.fees,
                  debtor_email: item.debtor_email
                };

                this.lstLetterData.push(letteData);
              }
            });
            
            let data = {
              data: this.lstLetterData
            }
            // ENVIAR EL ARREGLO DE DATOS
            this.$http
              .post(`${this.$urlApi}letters?token=${this.token}`, JSON.stringify(data), {
                headers: { "Content-Type": "application/json" },
              })
              .then(
                function (response) {
                  console.log(response);
                  hideLoader();
                  this.$swal({
                    title: "Buen trabajo",
                    text: "Operación exitosa!",
                    type: "success",
                    showCancelButton: false,
                    confirmButtonText: "Aceptar",
                  }).then((result) => {
                    if (result.value) {
                      this.getDebtors();
                      this.selectItems = [];
                      this.letter = null;
                      this.rowCount = 0;
                    }
                  });
                },
                (error) => {
                  console.log(error);
                  hideLoader();
                }
              );
          }

        });
      }else
      {
        this.$swal({
            title: "Oops...",
            text: "No ha seleccionado el tipo de carta a enviar.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
        return false;
      }
      
    },

    cancelSendLetter()
    {
      this.letter = null;
      for (var i = 0; i < this.items.length; i++) {
        var updatingItem = this.items[i];
        updatingItem.selected = false;
        this.$set(this.items, i, updatingItem);
      }
      this.selectItems = [];
    },

    getLetterPDF(item, type) 
    {
    showLoader();

    let info = JSON.stringify(
      {
        type: type,
        debtor_id: item.id,
        ineteres: item.ineteres,
        fees: item.fees
      });

    this.$http
      .post(
        `${this.$urlApi}report/letter/debtor?token=${this.token}`,
        info,
        {
          headers: { "Content-Type": "application/json" },
          responseType: "blob"
        }
      )
      .then(
        function(response) {
          console.log(response);
          _downloadFile(response, "letter-" + type + "-" + item.id);
          hideLoader();
        },
        error => {
          console.log(error);
          hideLoader();
        }
      );
    }

  },


};
</script>
